import HttpService from "./HttpService";
const API_URL = `/notifications`;

const NotificationService = {
  // params: optional { page, per_page, status: "read" | "unread", id } (also supports urgency/type/sender filters)
  fetch: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    try {
      const response = await HttpService.get(
        query ? `${API_URL}?${query}` : API_URL
      );
      // sendResponse envelope: { success, message, data: { notifications,
      // count, current_page, per_page, total, last_page } }. "count" is
      // just this page's item count — "total" is the real grand total.
      return response.data?.data ?? { notifications: [], count: 0, total: 0 };
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  },

  markAsRead: async (id) => {
    try {
      const response = await HttpService.post(`${API_URL}/${id}/read`);
      return response.data;
    } catch (error) {
      console.error("Error marking notification as read:", error);
      throw error;
    }
  },

  markAllAsRead: async () => {
    try {
      const response = await HttpService.post(`${API_URL}/read-all`);
      return response.data;
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
      throw error;
    }
  },
};

export default NotificationService;
